'use strict';

var _cart = require('./cart/cart');
var processInclude = require('base/util');
var baseFiles = {
  cart: function cart() {
    return _cart.init.call(_cart);
  }
};
module.exports = {
  baseFiles: baseFiles,
  loadFunctions: function loadFunctions() {
    Object.keys(baseFiles).forEach(function (key) {
      processInclude(baseFiles[key]);
    });
  }
};